import { Outlet } from "react-router-dom";

export function ClientLayout() {
  return (
    <div className="client-shell min-h-[100dvh]">
      <Outlet />
    </div>
  );
}

